import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

export interface GetBookingSnapshotsParams {
    workspaceID: string;
    startDate?: string;
    endDate?: string;
    order?: 'ASC' | 'DESC';
    groupBy?: string;
}

export const getBookingSnapshots = (params: GetBookingSnapshotsParams) => {
    const urlParams = new URLSearchParams();
    urlParams.append('workspaceID', params.workspaceID);
    if (params.startDate) urlParams.append('startDate', params.startDate);
    if (params.endDate) urlParams.append('endDate', params.endDate);
    if (params.order) urlParams.append('order', params.order);
    if (params.groupBy) urlParams.append('groupBy', params.groupBy);
    const url = `${OCTOPUS_BASE_URL}/booking-snapshots/?${urlParams.toString()}`;
    return axios.get(url);
};

export default getBookingSnapshots;
